import { post } from "../http/platformServer";

export function alibabaUidToNick(shopId: number, buyerUsername: string): Promise<string> {
    return post(shopId, "/alibaba/uid_to_nick", { shopId, buyerUsername });
}
